import { VFC } from "react";
// Resources
import styles from "../DropdownMenu.module.scss";

export const DropdownMenuSeparator: VFC = () => <hr className={styles.dropdown_menu__separator} />;
